module.exports = __webpack_public_path__ + "img/product-preview-40.9fc67f7.png";